import { useState } from 'react'

import { KW } from './theme'

const ArrowRight = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke={KW.muted}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="flex-shrink-0"
  >
    <path d="M5 12h14M13 6l6 6-6 6" />
  </svg>
)

interface Props {
  label: string
  onClick?: () => void
  disabled?: boolean
}

/** Full-width "Try asking" suggestion row from the empty state. */
const SuggestionButton = ({ label, onClick, disabled }: Props) => {
  const [hovered, setHover] = useState(false)
  const hover = hovered && !disabled
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      className="flex w-full cursor-pointer items-center gap-2 rounded-[10px] px-3 py-[9px] text-left text-[13px] font-semibold leading-[1.35]"
      style={{
        fontFamily: 'inherit',
        color: hover ? KW.ink : KW.body,
        background: hover ? '#f4fbfd' : '#fff',
        border: `1px solid ${hover ? KW.teal : KW.line2}`,
        opacity: disabled ? 0.55 : 1,
        cursor: disabled ? 'not-allowed' : undefined,
        transition: 'all .12s',
      }}
    >
      <ArrowRight />
      {label}
    </button>
  )
}

export default SuggestionButton
